import FormConfig from './formConfig/formConfigFile';
import Header from './layout/header';

import Gallery from './blocks/gallery';
import Timeline from './blocks/timeline';
import JobAlerts from './blocks/jobAlerts';
import JobCross from './blocks/jobCross';
import NewsCross from './blocks/newsCross';
import PlaceCross from './blocks/placeCross';
import KeyFigures from './blocks/keyfigures';
import EyeFollower from './modules/eyesFollower';
import Popup from './modules/popup';
import Loader from './modules/loader';
import AlternativeLayout from './modules/links/AlternativeLayout';
import './modules/avisSlider';
import { initMarqueeBlocks } from './blocks/marquee';
import { initGalleryTextBlocks } from './blocks/galleryText';
import { initMapBlocks } from './blocks/map';

window.addEventListener('DOMContentLoaded', () => {
    if (document.forms.length > 0) new FormConfig(); // eslint-disable-line

    // Set main color var
    if (document.querySelector('.header')) {
        const color = document.querySelector('.header').style.backgroundColor;
        document.documentElement.style.setProperty('--main-color', color);
    }

    // Button and gallery add aos
    const gutenbergs = document.querySelectorAll('.wp-block-button, .wp-block-gallery');
    gutenbergs.forEach((g) => {
        if (!g.getAttribute('data-aos')) {
            g.setAttribute('data-aos', 'zoom-in');
        }
    });

    /* eslint-disable no-new */
    new Header();
    new JobAlerts();
    new AlternativeLayout();

    // Popups
    new Popup();

    // Sliders
    new Gallery();
    new Timeline();

    // Crosscontent sliders
    new JobCross();
    new NewsCross();
    new PlaceCross();

    // Animations
    new KeyFigures();
    new EyeFollower();

    // Blocks
    initMarqueeBlocks();
    initGalleryTextBlocks();
    initMapBlocks();

    new Loader();
    /* eslint-enable no-new */

    /**
     * JobFilter all filter
     */
    const checkAll = document.querySelector('.jobsFilter__dropdown_field #all');
    if (checkAll) {
        checkAll.addEventListener('change', function filterCheckAll() {
            const others = this.parentNode.parentNode.querySelectorAll('input:not(#all)');
            Array.from(others).forEach((other) => {
                other.checked = this.checked; // eslint-disable-line
            });
        });
    }
});
